<template>
  <div>
    <b-button
      class="float-right"
      variant="flat-secondary"
      v-clipboard:copy="textToCopy"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    >
      <b-icon icon="files" font-scale="1.5"/>
    </b-button>
    <Prism>
      <slot></slot>
    </Prism>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import '@/libs/clipboard';

export default {
  components: {
    Prism,
  },
  computed: {
    textToCopy() {
      const defaultSlot = this.$slots.default || [];
      const text = defaultSlot
        .map((vnode) => vnode.text)
        .filter(Boolean)
        .join('')
        .trim();
      return text;
    },
  },
  methods: {
    onCopy() {
      this.$bvToast.toast('Successfully copied to clipboard!', { variant: 'success' });
    },
    onError() {
      this.$bvToast.toast('Failed to copy to clipboard!', { variant: 'danger' });
    },
  },
};
</script>
